import React, { useState, useEffect } from 'react';
import { Input, InputProps } from "tea-component";


// 数字输入组件的 props 类型
interface NumberInputProps extends InputProps {
  onChange?: (value: string) => void;
  min?: number;
  max?: number;
  allowNegative?: boolean;
  allowPositive?: boolean;
  allowDecimal?: boolean;
  allowInteger?: boolean;
  /** 是否允许清空；为 false 时不可删至空（如最小值为 1 的场景） */
  allowEmpty?: boolean;
}

// 生成动态正则表达式
const getNumberValidationRegex = ({
  allowNegative,
  allowDecimal
}: {
  allowNegative: boolean;
  allowDecimal: boolean;
}) => {
  let pattern = '^';
  
  // 处理负数
  if (allowNegative) {
    pattern += '-?';
  }
  
  // 整数部分规则：
  // 1. 可以是单独的0
  // 2. 或者非零数字开头，后面可以跟任意数字
  pattern += '(0|[1-9]\\d*)';
  
  // 处理小数
  if (allowDecimal) {
    // 允许：
    // 1. 小数点后跟数字（\.\d+）
    // 2. 或者单独的小数点（\.），以便用户正在输入
    pattern += '(\\.\\d*|\\.)?';
  }
  
  return new RegExp(`${pattern}$`);
};

const NumberInput: React.FC<NumberInputProps> = ({
  value: initialValue = '',
  onChange,
  min = -Infinity,
  max = Infinity,
  allowNegative = true,
  allowDecimal = true,
  allowEmpty = true,
  ...restProps
}) => {
  const [inputValue, setInputValue] = useState<string>(initialValue.toString());
  
  // 同步外部 value 变化
  useEffect(() => {
    setInputValue(initialValue === '' ? '' : initialValue.toString());
  }, [initialValue]);
  
  const handleChange = (rawValue: string) => {
    
    // 空值处理
    if (rawValue === '') {
      if (!allowEmpty) {
        return;
      }
      setInputValue('');
      onChange?.('');
      return;
    }
    
    // 特殊字符处理（仅在允许的情况下保留中间态 '-', '.'）
    const isAllowedMiddleToken =
      (rawValue === '-' && allowNegative) ||
      (rawValue === '.' && allowDecimal);
    if (isAllowedMiddleToken) {
      setInputValue(rawValue);
      return;
    }
    
    // 正则验证
    const regex = getNumberValidationRegex({allowNegative, allowDecimal});
    if (!regex.test(rawValue)) {
      return;
    }
    
    // 转换为数字验证范围
    const numericValue = parseFloat(rawValue);
    // 正则确保输入的是合法数字
    // if (isNaN(numericValue)) {
    //   // setError('请输入有效的数字');
    //   return;
    // }
    
    // 范围验证
    if (numericValue < min || numericValue > max) {
      return;
    }
    
    // 所有验证通过
    setInputValue(rawValue);
    onChange?.(rawValue);
  };
  
  const handleBlur = () => {
    // 处理不完整的输入
    if (inputValue === '-' || inputValue === '.') {
      if (!allowEmpty) {
        setInputValue(initialValue === '' ? '' : initialValue.toString());
        return;
      }
      setInputValue('');
      onChange?.('');
      return;
    }
    
    // if (inputValue === '') return;
    
    // const numericValue = parseFloat(inputValue);
    
    // 自动修正超出范围的值
    // if (numericValue < min) {
    //   setInputValue(min.toString());
    //   onChange?.(min);
    // } else if (numericValue > max) {
    //   setInputValue(max.toString());
    //   onChange?.(max);
    // }
  };
  
  return (
    <Input
      type="text"
      inputMode="decimal"
      value={inputValue}
      onChange={handleChange}
      onBlur={handleBlur}
      {...restProps}
    />
  );
};
export default NumberInput;